import { Component, OnInit, computed, inject, signal } from '@angular/core';

import { ButtonToggleComponent } from 'src/app/features/shared/controls/container/button-toggle/button-toggle.component';
import { ColorModePreference, colorModePreference } from '../theme-token-catalog';
import { IAutoComplete, autocomplete } from 'src/app/features/shared/controls/models/auto-complete.model';
import { SelectComponent } from 'src/app/features/shared/controls/container/select/select.component';
import { ThemeApiService } from '../theme-api.service';
import { ThemeService } from '../theme.service';
import { components } from 'src/assets/api/schema';

type ThemeListItemDto = components['schemas']['ThemeListDto'];

@Component({
    selector: 'app-theme-selector',
    templateUrl: './theme-selector.component.html',
    styleUrls: ['./theme-selector.component.scss'],
    standalone: true,
    imports: [ButtonToggleComponent, SelectComponent],
})
export class ThemeSelectorComponent implements OnInit {
    private __api = inject(ThemeApiService);
    protected _theme = inject(ThemeService);

    private __themes$$ = signal<ThemeListItemDto[]>([]);

    themes$$ = computed<IAutoComplete[]>(() => this.__themes$$().map(t => ({
        [autocomplete.itemId]: t.guid ?? '',
        [autocomplete.itemText]: `${t.name ?? ''}${t.isDefault ? ' (standaard)' : ''}`,
    })));

    // The dropdown follows the remembered selection, falling back to the active
    // theme's id (e.g. the backend default applied at boot).
    selectedGuid$$ = computed(() => this._theme.SelectedThemeGuid$$() ?? this._theme.Theme$$().id);

    readonly labels = {
        colorMode: 'weergave',
        theme: 'thema',
    } as const;

    readonly colorModes: IAutoComplete[] = [
        { [autocomplete.itemId]: colorModePreference.light,  [autocomplete.itemText]: 'licht' },
        { [autocomplete.itemId]: colorModePreference.dark,   [autocomplete.itemText]: 'donker' },
        { [autocomplete.itemId]: colorModePreference.system, [autocomplete.itemText]: 'systeem' },
    ];

    async ngOnInit(): Promise<void> {
        this.__themes$$.set(await this.__api.List_get());
        // Now that we're on an authenticated page, pull the user's stored prefs.
        await this._theme.SyncFromBackend();
    }

    emit_colorMode_change(mode: string | number): void {
        this._theme.SetColorMode(mode as ColorModePreference);
    }

    async emit_theme_change(guid: string | number): Promise<void> {
        await this._theme.SelectTheme(guid as string);
    }
}
